export const OPERATOR_ALIAS_METRIC_NAME = "OperatorAlias";
export const STATION_CODE_METRIC_NAME = "StationCode";
export const SCC_WEBSITE_METRIC_NAME = "StationCommandCenter";
export const OCULUS_SERVICE_METRIC_NAME = "OculusAssetsWebsite";
export const TRACKING_ID_METRIC_NAME = "TrackingId";
export const PUBLISH_KATAL_METRICS_FAILURE = "PublishKatalMetricsFailure";
export const KATAL_METRICS_PUBLISHER_PROCESS_NAME = "KatalMetricsPublisher";
export const SECURE_LENS_METHOD_METRIC_NAME = "SecureLens";
export const MEDIA_CATEGORY_METRIC_NAME = "MediaCategory";
export const MEDIA_CATEGORY_DEFAULT_METRIC_VALUE = "SCCMedia";


// WEBPACK FOOTER //
// ./src/commons/constants/MetricConstants.js